import { render, staticRenderFns } from "./Login-bak.vue?vue&type=template&id=260170d2&scoped=true"
import script from "./Login-bak.vue?vue&type=script&lang=js"
export * from "./Login-bak.vue?vue&type=script&lang=js"
import style0 from "./Login-bak.vue?vue&type=style&index=0&id=260170d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260170d2",
  null
  
)

export default component.exports